import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    getZoneResources({ uuid }) {
      const state = getState().find(({ zone }) => zone.uuid === uuid);

      return state ? state.resources : [];
    },
    isZoneResourcesRetrievalRequestFailure({ uuid }) {
      const state = getState().find(({ zone }) => zone.uuid === uuid);

      return state ? state.request.isFailure : false;
    },
    isZoneResourcesRetrievalRequestPending({ uuid }) {
      const state = getState().find(({ zone }) => zone.uuid === uuid);

      return state ? state.request.isPending : false;
    },
    isZoneResourcesRetrievalRequestSuccess({ uuid }) {
      const state = getState().find(({ zone }) => zone.uuid === uuid);

      return state ? state.request.isSuccessful : false;
    },
  };
}

export { createSelector };
